export { default as OrganizationsSubTable } from './organizations-sub-table';
